import { default as hour } from './hour/routes'
import { default as base_hour } from './base_hour/routes'

export default [
    ...hour,
    ...base_hour,
]